import React from 'react';

const Vue_beforeUnmount = () => {
  return (
    <div>
      <h1>Vue_beforeUnmount Component</h1>
      <p>This is the Vue_beforeUnmount tutorial page.</p>
    </div>
  );
}

export default Vue_beforeUnmount;
